<template>
  <div class="top-tool">
    <div class="tool-right">
      <div class="tool-menu">
        <i style="color: rgb(40, 124, 176)" class="el-icon-document-add"></i>
        添加当前预设
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // name: 'card-M',
  props: {

  },
  methods: {}
};
</script>

<style scoped lang="scss">
.top-tool {
  /* 卡片 */
  position: relative;
  //width: 996px;
  // width: 80%;
  width: 40%;
  min-width: 350px;
  height: 30px;//这个地方时生产预设里添加当前预设的高度控制
  /*top: 20px;*/
  // background: rgb(0, 255, 255);
  background: rgb(255, 255, 255);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px 0 20px;
  /*margin-left: 20px;*/
}
.tool-right {
  display: flex;
  // width: 60%;
  justify-content: space-around;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  width: 150px;
}
.tool-menu {
  cursor: pointer;
  min-width: 80px;
  color: rgba(0, 0, 0, 0.5);

}
</style>
